<ng-container *ngIf="showNavigationArrows">
	<div class="arrowsWrapper" [ngClass]="{'disabled': activeView !== 'month'}">
		<div class="arrowsContainer">
			<div class="arrow">
				<div [class]="{'disabled': !displayPrevArrow()}" (click)="activeView === 'month' && displayPrevArrow() && updateFocusedDate(-1);" title="{{'PrevMonth'| cpActionTranslate}}"><i class="cp-sh-icon-arrow_previous"></i></div>
			</div>
			<div class="arrow">
				<div [class]="{'disabled': !displayNextArrow()}" (click)="activeView === 'month' && displayNextArrow() && updateFocusedDate(1);" title="{{'NextMonth' | cpActionTranslate}}"><i class="cp-sh-icon-arrow_next"></i></div>
			</div>
		</div>
	</div>
</ng-container>
<kendo-calendar
		[focusedDate]="activeDate"
		[navigation]="false"
		[value]="date"
		[(activeView)]="activeView"
		(activeViewDateChange)="activeDate = $event;updateData()"
		(valueChange)="activeDate = $event; dateChange.emit($event)"
		[min]="min"
		[max]="max"
		(activeViewChange)="onActiveViewChange($event)">
	<kendo-calendar-messages
		[parentViewButtonTitle]="'CalendarParentViewNavigation' | cpActionTranslate">	
	</kendo-calendar-messages>
	<ng-template kendoCalendarMonthCellTemplate let-date>
		<span *ngIf="markerFunction; else stndDate" [ngClass]="markerFunction(date)">
			{{date.getDate()}}
			<div *ngIf="showHijri && showHijriDate" class="hijri-date">{{(hijriDateService.hijriDatesObservable | async) | cpHijriDate: date: "iD"}}</div>
		</span>
		<ng-template #stndDate>
			<span>{{date.getDate()}}</span>
			<div *ngIf="showHijri && showHijriDate" class="hijri-date">{{(hijriDateService.hijriDatesObservable | async) | cpHijriDate: date: "iD"}}</div>
		</ng-template>
	</ng-template>

	<ng-template kendoCalendarHeaderTitleTemplate let-date="date"
				 let-title
				 let-view="activeView">
					<span class="custom custom-header-button title">
							{{title}}
						<div *ngIf="showHijri && showHijriDate" class="hijri-date">{{ (hijriDateService.hijriDatesObservable | async)| cpHijriDate: date: "": view }}</div>
					</span>
	</ng-template>

	<ng-template kendoCalendarYearCellTemplate let-context="cellContext" *ngIf="showHijri">
					<span class="custom">
							{{context.formattedValue}}
						<div *ngIf="showHijri && showHijriDate"
							 class="hijri-date" style="height: 55px;">{{(hijriDateService.hijriDatesObservable | async) | cpHijriDate: context.value: "iMMMM":"month"}}</div>
					</span>
	</ng-template>

	<ng-template kendoCalendarDecadeCellTemplate let-context="cellContext" *ngIf="showHijri">
					<span class="custom">
							{{context.formattedValue}}
						<div *ngIf="showHijri && showHijriDate"
							 class="hijri-date">{{(hijriDateService.hijriDatesObservable | async) | cpHijriDate: context.value: "iYYYY":"year"}}</div>
					</span>
	</ng-template>
</kendo-calendar>
